<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <sidebar-admin></sidebar-admin>

        <main role="main" class="ml-sm-auto col-10">
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 px-4"
          >
            <h1 class="h2">產品列表</h1>
            <button @click="openModal(true, undefined ,'reserve')" type="button" class="btn btn-outline-primary">新建商品</button>
          </div>
          <div class="table-responsive">
            <table class="table mt-4">
              <thead>
                <tr>
                  <th width="120">分類</th>
                  <th>產品名稱</th>
                  <th width="120">原價</th>
                  <th width="120">售價</th>
                  <th width="100">是否啟用</th>
                  <th width="130">編輯</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item) in products" :key="item.id">
                  <td>{{ item.category }}</td>
                  <td>{{ item.title }}</td>
                  <td class="text-right">{{ item.origin_price | currency}}</td>
                  <td class="text-right">{{ item.price | currency}}</td>
                  <td>
                    <span v-if="item.is_enabled" class="text-success">啟用</span>
                    <span v-else>未啟用</span>
                  </td>
                  <td>
                    <button @click="openModal(false, item, 'reserve')" class="btn btn-outline-primary btn-sm mr-2">編輯</button>
                    <button @click="openModal(undefined, item, 'delete')" class="btn btn-outline-dark btn-sm">刪除</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination v-on:changePage-getPagination="getAdminProduct"></Pagination>
          </div>
        </main>
      </div>
    </div>

    <!-- 新增產品modal -->
    <div
      class="modal fade"
      id="productModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content border-0">
          <div class="modal-header bg-dark text-white">
            <h5 class="modal-title" id="exampleModalLabel">
              <span>新增產品</span>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="image">輸入圖片網址</label>
                  <input v-model="tempProduct.imageUrl" type="text" class="form-control" id="image" placeholder="請輸入圖片連結">
                </div>
                <div class="form-group">
                  <label for="customFile">
                    或 上傳圖片
                    <i v-if="isLoadingShow" class="fas fa-spinner fa-spin"></i>
                  </label>
                  <input type="file" id="customFile" class="form-control"
                    ref="files"
                    @change="uploadFile">
                </div>
                <img
                  :src="tempProduct.imageUrl"
                  class="img-fluid"
                  alt
                >
              </div>
              <div class="col-sm-8">
                <div class="form-group">
                  <label for="title">標題</label>
                  <input v-model="tempProduct.title" type="text" class="form-control" id="title" placeholder="請輸入標題">
                </div>

                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="category">分類</label>
                    <input v-model="tempProduct.category" type="text" class="form-control" id="category" placeholder="請輸入分類">
                  </div>
                  <div class="form-group col-md-6">
                    <label for="price">單位</label>
                    <input v-model="tempProduct.unit" type="unit" class="form-control" id="unit" placeholder="請輸入單位">
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="origin_price">原價</label>
                    <input v-model="tempProduct.origin_price" type="number" class="form-control" id="origin_price" placeholder="請輸入原價">
                  </div>
                  <div class="form-group col-md-6">
                    <label for="price">售價</label>
                    <input v-model="tempProduct.price" type="number" class="form-control" id="price" placeholder="請輸入售價">
                  </div>
                </div>
                <hr>

                <div class="form-group">
                  <label for="description">產品描述</label>
                  <textarea v-model="tempProduct.description" type="text" class="form-control" id="description" placeholder="請輸入產品描述"></textarea>
                </div>
                <div class="form-group">
                  <label for="content">說明內容</label>
                  <textarea v-model="tempProduct.content" type="text" class="form-control" id="content" placeholder="請輸入產品說明內容"></textarea>
                </div>
                <div class="form-group">
                  <div class="form-check">
                    <input v-model="tempProduct.is_enabled" class="form-check-input" type="checkbox" id="is_enabled">
                    <label class="form-check-label" for="is_enabled">是否啟用</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">取消</button>
            <button @click="addAdminProductThenClose({ isNew: isNew, data: tempProduct, id: tempProduct.id })" type="button" class="btn btn-primary">確認</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 確認刪除modal -->
    <div
      class="modal fade"
      id="delProductModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content border-0">
          <div class="modal-header bg-danger text-white">
            <h5 class="modal-title" id="exampleModalLabel">
              <span>刪除產品</span>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            是否刪除
            <strong class="text-danger">{{ tempProduct.title }}</strong> 商品(刪除後將無法恢復)。
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">取消</button>
            <button @click="deleteProduct(tempProduct.id)" type="button" class="btn btn-danger">確認刪除</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import $ from 'jquery'
import 'bootstrap/dist/js/bootstrap.bundle.js'
import SidebarAdmin from '@/components/admin/Sidebar.vue'
import Pagination from '@/components/Pagination.vue'

export default {
  name: 'lessonAdmin',
  data () {
    return {
      tempProduct: {},
      isLoadingShow: false,
      isNew: true
    }
  },
  components: {
    SidebarAdmin,
    Pagination
  },
  computed: {
    products () {
      return this.$store.state.storeAdmin.products
    },
    pagination () {
      return this.$store.state.storeBasic.pagination
    }
  },
  methods: {
    ...mapActions({
      getAdminProduct: 'storeAdmin/getAdminProduct',
      addAdminProduct: 'storeAdmin/addAdminProduct',
      updateMessage: 'updateMessage'
    }),
    openModal (boolForNew, item, style) {
      this.$refs.files.value = '' // 每次打開都將上傳檔案的欄位重新設置
      if (style === 'reserve') {
        if (boolForNew) {
          this.tempProduct = {}
          this.isNew = true
        } else {
          this.tempProduct = Object.assign({}, item)
          this.isNew = false
        }
        $('#productModal').modal('show')
      } else if (style === 'delete') {
        this.tempProduct = Object.assign({}, item)
        $('#delProductModal').modal('show')
      }
    },
    closeModal (style) {
      if (style === 'reserve') {
        $('#productModal').modal('hide')
      } else if (style === 'delete') {
        $('#delProductModal').modal('hide')
      }
    },
    async addAdminProductThenClose ({ isNew, data, id }) {
      await this.addAdminProduct({ isNew, data, id })
      this.closeModal('reserve')
    },
    uploadFile () {
      const vm = this
      const api = `${process.env.VUE_APP_API_BASE_URL}/api/${process.env.VUE_APP_CUSTOM_PATH}/admin/upload`
      let formData = new FormData()
      let img = this.$refs.files.files[0]
      vm.isLoadingShow = true
      formData.append('file-to-upload', img)
      this.$http.post(api, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((res) => {
        console.log('[新增照片]', res.data)
        vm.isLoadingShow = false
        if (res.data.success) {
          vm.$set(vm.tempProduct, 'imageUrl', res.data.imageUrl)
          vm.updateMessage({ message: '新增照片成功', status: 'success' })
          // vm.$bus.$emit('message:push', '新增照片成功', 'success')
        }
      })
    },
    deleteProduct (id) {
      const vm = this
      const api = `${process.env.VUE_APP_API_BASE_URL}/api/${process.env.VUE_APP_CUSTOM_PATH}/admin/product/${id}`
      this.$http.delete(api).then((res) => {
        if (res.data.success) {
          vm.getAdminProduct({ page: vm.pagination.current_page })
          vm.closeModal('delete')
        }
      })
    }
  },
  created () {
    this.getAdminProduct({ page: 1 })
  }
}
</script>

<style lang="scss" scoped>
</style>
